import React from 'react';
import { useNavigate } from 'react-router-dom';

export const MeetEmbebida: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <button
        type="button"
        onClick={() => { window.history.length > 1 ? navigate(-1) : navigate('/sessions'); }}
        style={{
          position: 'fixed',
          top: '4.5rem',
          left: '1rem',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.375rem',
          padding: '0.5rem 1rem',
          background: '#fff',
          color: '#374151',
          border: '1px solid #d1d5db',
          borderRadius: '9999px',
          fontSize: '0.875rem',
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          zIndex: 200,
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.borderColor = '#9ca3af'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#d1d5db'; }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Volver
      </button>
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: 0 }}>
        <iframe
          src="https://call.nocoda.ai/?room=process_12345&access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NzAwNDAzMjksImlzX2FkbWluIjp0cnVlLCJpc3MiOiJBUElLQ1NVS1czTGZURiIsIm5hbWUiOiJMaWMuIE1hcmluYSBNYW1tb2xpdHRpIiwibmJmIjoxNzY5NDQwMzI5LCJyb29tX2lkIjoicHJvY2Vzc18xMjM0NSIsInN1YiI6InBzeS0wMDEiLCJ1c2VyX2lkIjoicHN5LTAwMSJ9.-SoKAowHIjGTA6BF3NqwlS1K_DFynOEWxIJ44FNkyCw&custom_design=%7B%22custom_css_url%22%3A%22https%3A%2F%2Fcall.nocoda.ai%2Fembedded%2Fclean.css%22%7D"
          style={{ width: '100%', height: '80vh', border: 0, borderRadius: '16px', overflow: 'hidden' }}
          allow="camera; microphone; fullscreen; display-capture"
          allowFullScreen
          title="Meet embebida"
        />
      </div>
    </>
  );
};

export default MeetEmbebida;
